// src/components/ui/InputField.jsx
const InputField = ({ label, className = "", ...props }) => (
  <div>
    {label && (
      <label className="block text-sm font-medium text-gray-700 mb-1">
        {label}
      </label>
    )}
    <input
      {...props}
      className={`
    w-full min-w-0 appearance-none
    border border-gray-200 rounded-lg
    px-3 py-2 text-base
    bg-white
    focus:outline-none focus:ring-2 focus:ring-blue-500
    transition placeholder-gray-400
    disabled:bg-gray-50 disabled:text-gray-400
    ${className}
  `}
    />
  </div>
);

export default InputField;
